import _ from 'lodash'
import {createContext, FC, useContext, useEffect, useState} from 'react'

import {Faq} from '@/content/FAQs'

type HelpCenterContextType = {
  isActive: boolean
  setIsActive: (isActive: boolean) => void
  activeFaq: Faq | null
  setActiveFaq: (activeFaq: Faq | null) => void
  // Set ahead of opening (e.g. on hovering the help button), so the drawer is ready when it opens
  isLoadRequested: boolean
  requestLoad: () => void
}

const HelpCenterContext = createContext<HelpCenterContextType>({
  isActive: false,
  setIsActive: _.identity,
  activeFaq: null,
  setActiveFaq: _.identity,
  isLoadRequested: false,
  requestLoad: _.noop,
})

export const useHelpCenterContext = (): HelpCenterContextType => useContext(HelpCenterContext)

export const HelpCenterProvider: FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const [isActive, setIsActive] = useState(false)
  const [activeFaq, setActiveFaq] = useState<Faq | null>(null)
  const [isLoadRequested, setIsLoadRequested] = useState(false)

  useEffect(() => {
    if (activeFaq !== null) {
      setIsActive(true)
      setActiveFaq(activeFaq)
    }
  }, [activeFaq])

  return (
    <HelpCenterContext.Provider
      value={{
        isActive,
        setIsActive,
        activeFaq,
        setActiveFaq,
        isLoadRequested,
        requestLoad: () => setIsLoadRequested(true),
      }}
    >
      {children}
    </HelpCenterContext.Provider>
  )
}
